import { createSlice } from "@reduxjs/toolkit";

export interface FeedMetaShape {
    productCount?: number;
    retailerCount?: number;
}

const feedCount = createSlice({
    name: "feedCount",
    initialState: {
        productCount: undefined,
        retailerCount: undefined,
    } as FeedMetaShape,
    reducers: {
        setAll(state, action): void {
            state.productCount = action.payload.product_count;
            state.retailerCount = action.payload.retailer_count;
        },
    },
});

export const { setAll } = feedCount.actions;
export default feedCount.reducer;
